var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-input',{attrs:{"id":_vm.context.id,"disabled":""},model:{value:(_vm.folio),callback:function ($$v) {_vm.folio=$$v},expression:"folio"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }